import * as React from 'react';
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { msalConfig } from "../../types/msalAuthConfig";
import { ILoginViewModel } from '../../types/ILoginViewModel';
import { Redirect } from 'react-router-dom';
import { If } from '../../../core/components/If';
import { B2C_LOGIN_TYPE } from '../../Consts';
import axiosInstance, { attachMembersPortalMsalInterceptor } from "../../../setupAxios";
import { MembersPortalService } from '../../../redux/services/MembersPortalService';
import { IMembersPortalRoleAssignment } from '../../../redux/types/IMembersPortalRoleAssignment';
import { AppInsightsService } from '../../../telemetry/services/AppInsightsService';

interface IB2CAuthenticatedProps {
    login: (viewModel: ILoginViewModel, redirect: any) => void;
    redirect?: any;
    isSignedIn: boolean;
    portalType: string;
}

export const B2CAuthenticated = ({ login, redirect, isSignedIn, portalType }: IB2CAuthenticatedProps) => {
    const { instance, accounts } = useMsal();
    const account = accounts[0]

    useEffect(() => {
        const username = account.name;
        let vm: ILoginViewModel = {
            email: null,
            password: null,
            rememberMe: true,
            loginType: B2C_LOGIN_TYPE,
            username: username
        }
        attachMembersPortalMsalInterceptor(instance, account);
        login(vm, redirect);
    }, []);

    return (
        <If condition={isSignedIn}>
            <Redirect to={'/'} />
        </If>
    );
}